module.exports = __webpack_public_path__ + "static/img/brief-tit.e57529f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brief-tit.png
// module id = uLM9
// module chunks = 0